import React, { useEffect, useState } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';
// import { initializeApp } from 'firebase/app';
// import { firebaseConfig } from '../firebaseConfig'; // your Firebase config
import HotelSearchBar from '../../common/HotelSearchBar';
// import HotelCard from '../../common/HotelCard';
import { database } from '../../auth/firebase';
import Footer from '../../common/Footer';
import Nav from '../../common/Nav';
import HotelCard, { FilterDropdown } from './HotelCard';
import FilterSidebar from './FilterSideBarrr';
import MobileFilters from './MobileFilters';


// initializeApp(firebaseConfig);

const HotelList = () => {
  const [hotels, setHotels] = useState([]);
  const [search, setSearch] = useState('');
  // const [filters, setFilters] = useState({});
  const [isMobileFilterOpen, setMobileFilterOpen] = useState(false);
  const hotelsPerPage = 4;
  const [visibleCount, setVisibleCount] = useState(hotelsPerPage);
  const [filters, setFilters] = useState({
    popular: [],
    rating: null,
    HotelType: "",
  });



  useEffect(() => {
    // const db = getDatabase();
    const hotelRef = ref(database, 'hotels');
    onValue(hotelRef, (snapshot) => {
      const data = snapshot.val();
      const formatted = Object.entries(data || {}).map(([id, value]) => ({
        id,
        ...value,
      }));
      setHotels(formatted);
    });
    console.log("hotel::: ", hotels)
  }, []);

  var filtered = hotels.filter((hotel) =>
    hotel.name.toLowerCase().includes(search.toLowerCase())
  );
  const [selectedOption, setSelectedOption] = useState("popularity");

  const handleChange = (newOption) => {
    setSelectedOption(newOption);
    // Optionally apply sorting logic here
    console.log("Selected filter:", newOption);
  };

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + hotelsPerPage);
  };

  const isAllLoaded = visibleCount >= filtered.length;

  const handleFilterChange = (updatedFilters) => {
    setFilters(updatedFilters);
    
    // Optional: trigger API/filter function here
    console.log("Filters applied:", updatedFilters);
  };
  // const normalizeHotelType = (type) => {
  //   return type?.toLowerCase().replace(/\s+/g, " ").replace("star", "") + "star";
  // };
  const normalizeHotelType = (type) => {
    if (!type) return "";
    return type.trim().toLowerCase().replace(/\s+/g, " ").replace("star", "") + "star";
  };
  const applyFilters = (hotels, filters) => {
    const selectedPopular = filters.popular || [];

    return hotels.filter((hotel) => {
      const normalizedHotelType = normalizeHotelType(hotel.type || "");
      const hotelRating = parseFloat(hotel.rating);
      const hotelAmenities = hotel.amenities?.toLowerCase() || "";



      //--- Search Functionality ---
      if(!hotel.name.toLowerCase().includes(search.toLowerCase())) return false;

      // --- RATING FILTER ---
      if (filters.rating === "Exceptional: 9+" && hotel.rating < 9) return false;
      if (filters.rating === "Excellent: 8+" && hotel.rating < 8) return false;
  
      // --- POPULAR FILTERS ---
      if (filters.popular.includes("Free Cancellation") && hotel.amenities.includes("Free Cancellation"))
        return false;
      if (filters.popular.includes("Free Breakfast") && !hotel.amenities.includes("Free breakfast"))
        return false;
      if (filters.popular.includes("Rated Exceptional(9+)") && hotel.rating < 9)
        return false;
      if (filters.popular.includes("Parking Available") && !hotel.amenities.includes("parking"))
        return false;
  
      // --- HOTEL TYPE ---
      if (
        filters.hotelType?.length > 0 &&
        (!hotel.type || !filters.hotelType.includes(normalizedHotelType))
      ) {
        return false;
      }

      //---mobile filters---
      if (
        selectedPopular.includes("Rated Excellent(9+)") &&
        hotelRating < 9
      ) return false;
  
      // === AMENITIES from popular (mobile) ===
      if (
        selectedPopular.includes("Free Cancellation") &&
        !hotelAmenities.includes("free cancellation")
      ) return false;
  
      if (
        selectedPopular.includes("Free Breakfast") &&
        !hotelAmenities.includes("free breakfast")
      ) return false;
  
      if (
        selectedPopular.includes("Parking Available") &&
        !hotelAmenities.includes("parking")
      ) return false;
      //---mobile hotel type filter---
      const mobileTypes = ["3 Star", "4 Star", "5 Star"];
      const matchedType = mobileTypes.find((t) => selectedPopular.includes(t));
      if (matchedType) {
        const normalizedTargetType = normalizeHotelType(matchedType);
        if (normalizedHotelType !== normalizedTargetType) return false;
      }
  
      // All filters passed
      return true;
    });
  };
  // useEffect(()=>{
  //     filtered = applyFilters(filtered,filters);
  // },[])
  filtered = applyFilters(hotels,filters)||filtered;
  return (
    <div >
      <div>
        <Nav />
      </div>
      <div className=" relative p-4 md:px-20 my-20  ">

        <HotelSearchBar value={search} onChange={setSearch} />


        <div className='relative flex p-2 '>
          <h2 className="text-2xl font-semibold mb-4 ">Showing Properties in {search} </h2>

          {/* <div className='relative   '>
            <FilterDropdown selectedOption={selectedOption} onChange={handleChange} />
          </div> */}


        </div>
        <section className=' overflow-y-auto my-4  h-auto'>
          <div className="flex flex-col lg:flex-row">
            <FilterSidebar filters={filters} onFilterChange={handleFilterChange} />

            <div className="flex-1 px-4">
              <div className="sticky top-0 z-10 bg-white pt-4">
                <MobileFilters filters={filters.popular} onFilterChange={handleFilterChange}/>
              </div>

              <div className='relative  mt-12 lg:pl-24 lg:ml-24 overflow-y-auto h-auto'>


              <div className=" flex flex-col  lg:grid  lg:col-span-2 gap-6 overflow-y-auto h-fit lg:h-screen max-h-full  scroll-bar pb-24">

                {/* {filtered.map((hotel) => ( */}

                {filtered.slice(0, visibleCount).map((hotel, index) => (
                  // <HotelCard key={hotel.id} hotel={hotel} />
                  //           <HotelCard hotel={{
                  //   image: "https://example.com/hotel.jpg",
                  //   title: "Snow Valley Resorts Shimla",
                  //   location: "Kachi Ghatti",
                  //   distance: "3.7 km",
                  //   rating: 8.4,
                  //   reviews: 1310,
                  //   price: 4568,
                  //   originalPrice: 7000,
                  //   discount: 2432,
                  //   roomsLeft: 1,
                  //   taxesAndFees: 1174,
                  //   exclusiveDeal: true,
                  // }} />

                  <HotelCard hotel={hotel} />


                ))}
                {/* Load More Button */}

              </div>
              {!isAllLoaded && (
                <div className="flex justify-center mt-6">
                  <button
                    onClick={handleLoadMore}
                    className="px-6 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition"
                  >
                    Load More
                  </button>
                </div>
              )}
            </div>
            </div>
          </div>
        </section>
        <section className='relative lg:flex flex-col lg:flex-row h-auto mb-12 top-0 z-10'>
          <div className='relative'>
            <div className='absolute overflow-y-auto my-4  h-auto'>
              {/* <div className="flex flex-col lg:flex-row">
      <FilterSidebar filters={filters} onFilterChange={handleFilterChange} />

      <div className="flex-1 px-4">
        <div className="sticky top-0 z-10 bg-white pt-4">
          <MobileFilters filters={filters.popular} />
        </div>

      </div>
    </div> */}
              {/* <aside className={`sm:w-full lg:w-5/6 h-auto m-12 bg-white  mx-8 border border-gray-200 rounded-2xl shadow-lg 
                         lg:block`}>
              <FilterSidebar
                filters={filters}
                setFilters={setFilters}
                location={search}
                onClose={() => setMobileFilterOpen(false)}
                hotelData={filtered}
              />
            </aside> */}

              {/* Toggle for mobile */}
              {/* <button
              className="hidden m-8 bg-blue-500 text-white px-4 py-2 rounded "
              onClick={() => setMobileFilterOpen(true)}
            >
              Show Filters
            </button> */}
            </div>
          </div>

          <section className='relative w-full h-auto lg:pl-24 lg:ml-24 mb-12'>
            {/* <div className='relative  mt-12 lg:pl-24 lg:ml-24 overflow-y-auto h-auto'>


              <div className="  lg:grid col-span-2 gap-6 overflow-y-auto h-screen max-h-full  scroll-bar pb-24">


                {filtered.slice(0, visibleCount).map((hotel, index) => (
                 

                  <HotelCard hotel={hotel} />


                ))}

              </div>
              {!isAllLoaded && (
                <div className="flex justify-center mt-6">
                  <button
                    onClick={handleLoadMore}
                    className="px-6 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition"
                  >
                    Load More
                  </button>
                </div>
              )}
            </div> */}
          </section>

        </section>

      </div>
      <Footer />
    </div>
  );
};

export default HotelList;
